/** Shared count pluralization for pull-plan scope labels ("3 levels · 87
 *  activities"), so the board and the review header read identically. */
export const lvlWord = (n: number): string => (n === 1 ? "level" : "levels");
export const actWord = (n: number): string => (n === 1 ? "activity" : "activities");
